import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { UserAgreementComponent } from '../../common/components/user-agreement/user-agreement.component';
import { AuthService } from 'src/app/services/security/auth.service';
import { UserApiService } from 'src/app/services/user-api/user-api.service';
import { environment } from 'src/environments/environment';
import { switchMap } from 'rxjs';

@Component({
  selector: 'app-post-login-agreement',
  standalone: true,
  imports: [UserAgreementComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  template: `
    @if (isLoading) {
      <fds-loading-indicator></fds-loading-indicator>
    } @else {
      <app-user-agreement
        [showActions]="showActions"
        (accepted)="onAccepted()"
      />
    }
  `,
})
export class PostLoginAgreementComponent implements OnInit {
  isLoading = true;
  showActions = false;

  constructor(
    private readonly authService: AuthService,
    private readonly userApiService: UserApiService,
  ) {}

  ngOnInit(): void {
    this.userApiService.getTerms().subscribe({
      next: (terms) => {
        this.showActions = !terms.isAccepted;
        this.isLoading = false;
      },
    });
  }

  onAccepted(): void {
    this.isLoading = true;
    this.userApiService
      .saveTerms(true)
      .pipe(switchMap(() => this.authService.login()))
      .subscribe({
        next: (success) => {
          if (success) {
            this.location.assign(environment.loginRedirectPath);
          }
        },
      });
  }

  private get location(): Location {
    return window.location;
  }
}
